// extracted by mini-css-extract-plugin
export default {"tableSize":"style_tableSize__VeyVj"};